var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dryness-template',{attrs:{"considerable-dryness":_vm.considerableDryness,"skin-dryness":_vm.skinDryness,"flaking-skin":_vm.flakingSkin,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }